export default {"src":"//prod.smassets.net/assets/smweb/_next/static/media/sm-primary-logo.e33a82a9.svg","height":29,"width":199,"blurWidth":0,"blurHeight":0};